// extracted by mini-css-extract-plugin
export default {"container":"WarrantyResultPanel_container__UA6H2","title":"WarrantyResultPanel_title__PFe5n"};